export default __webpack_public_path__ + "08626a3ef184ed93033ad6fdc1bf4b74.svg";